module.exports = __webpack_public_path__ + "static/aso2-baa2a2cc5af2dba08dde1b9c8d21e86a.png";